import { TableCell, tableCellClasses, checkboxClasses } from '@mui/material';
import { styled } from '@mui/material/styles';
import { colors } from 'Constants/Colors';
import { tablePaginationClasses } from '@mui/material/TablePagination';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: colors.BLUE_GRAY,
    color: theme.palette.common.black,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const tablePaginationStyle = {
  [`& .${tablePaginationClasses.selectLabel}`]: {
    fontFamily: 'var(--app-font)',
  },
  [`& .${tablePaginationClasses.displayedRows}`]: {
    fontFamily: 'var(--app-font)',
  },
  [`& .${tablePaginationClasses.select}`]: {
    fontFamily: 'var(--app-font)',
  },
};

const tableContainerStyle = {
  background: 'white',
  width: '95%',
  maxHeight: '60vh',
  margin: 'auto',
  borderBottom: 'none',
};

const tableStyle = {
  minWidth: 650,
  borderCollapse: 'separate',
  borderSpacing: '0px 5px',
  background: `${colors.BLUE_GRAY} !important`,
  height: '20vh',
  overflow: 'auto',
  [`& .${tableCellClasses.root}`]: {
    fontFamily: 'var(--app-font)',
    borderBottom: 'none',
  },
  [`& .${checkboxClasses.checked}`]: { color: `${colors.GREEN} !important` },
};

const tableHead = {
  background: colors.BLUE_GRAY,
};

const tableRowStyle = {
  '&:last-child td, &:last-child th': { border: 0 },
  background: 'white',
  '&:hover': {
    cursor: 'pointer',
    background: '#EEF2FB',
  },
  height: '25%',
};
const subtableRowStyle = {
  '&:last-child td, &:last-child th': { border: 0 },
  [`& .${tableCellClasses.root}`]: {
    marginTop: 0,
  },
  background: 'white',
};

const tableCellStyle = {
  fontWeight: 'bold',
};

export default {
  tableContainerStyle,
  tableStyle,
  tableHead,
  tableRowStyle,
  tableCellStyle,
  subtableRowStyle,
  StyledTableCell,
  tablePaginationStyle,
};
